import * as ko from 'knockout';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { BlockUI } from 'Core/Common/BlockUi';
import {
    FlowFolderPopover,
    FlowFolderPopoverOptions,
} from 'Core/Components/FlowFolderPopover/FlowFolderPopover';

import { SearchScreenStore } from 'Core/Screens/SearchScreen/Stores/SearchScreenStore';
import { UserVarsManager } from 'Core/UserVarsManager/UserVarsManager';
import { PUB_SUB_EVENTS } from 'MenuManager/PubSubEvents';
import { Event } from 'Core/Common/Event';
import { LABELS } from 'Core/Components/Translation/Locales';
import { JBoxDropDown } from '../JBoxDropdown/DropDown';
import { MobileChecker } from '../../Common/MobileChecker';

import RecentAndFavoritesTemplate from 'Core/Components/RecentAndFavorites/RecentAndFavorites.html';

export class RecentAndFavorites extends Event {
    private _entityId: number;
    private _entityName: string;
    private _recentList: KnockoutObservableArray<any>;
    private _favoritesList: KnockoutObservableArray<any>;
    private LABELS: any;
    private dataLoaded: KnockoutObservable<boolean>;
    private _flowFolder: boolean;
    private _dropDown: any;
    private _targetElem: HTMLElement;
    private _isMobile: KnockoutObservable<boolean>;
    private _flowFolderPopover: FlowFolderPopover;

    constructor(entity, target, flowFolder: boolean) {
        super();

        this._entityId = entity.Table.Id;
        this._entityName = entity.Table.Name;
        this._recentList = ko.observableArray([]);
        this._favoritesList = ko.observableArray([]);
        this._flowFolder = flowFolder;
        this._targetElem = target;
        this._isMobile = ko.observable(MobileChecker.IsMobile());

        this.LABELS = LABELS;
        this.dataLoaded = ko.observable(false);
        this._flowFolderPopover = new FlowFolderPopover();

        this.Init();
    }

    Init() {
        if (!this._isMobile()) {
            this.InitRecentAndFavoritesDropdown(this._targetElem);
        }
        let elem = $('.recent-and-favorites-dropdown .jBox-container');
        BlockUI.Block({ Target: elem.get(0) });

        SearchScreenStore.GetScreenModel({ EntityId: this._entityId, TableName: this._entityName })
            .then((data) => {
                this._recentList(data.GroupNameToRecords.recent);
                this._favoritesList(data.GroupNameToRecords.favorites);
                this.dataLoaded(true);
                if (!this._isMobile()) {
                    if (this._dropDown) {
                        this._dropDown.SetContent({ content: this.GetTemplate() as any });
                    }

                    if (this._flowFolder) {
                        const recentListContainer = $('.recent-block-list');
                        let recentListItems = recentListContainer.children();

                        _.each(recentListItems, (el) => {
                            const $el: any = $(el);
                            setTimeout(() => {
                                const resizeObserver = new ResizeObserver(() => {
                                    let options: FlowFolderPopoverOptions = {
                                        EntityId: this._entityId,
                                        RecordId: this._recentList()[recentListItems.index(el)].Id,
                                        PopoverOptions: {
                                            Element: $el,
                                            Container: recentListContainer,
                                            Viewport: recentListContainer,
                                            Placement: 'right',
                                            Trigger: 'manual',
                                            CustomTemplateClass:
                                                'recent-block-list-container__flow-folder-popover',
                                        },
                                    };
                                    this._flowFolderPopover.Init(options);
                                });

                                resizeObserver.observe(el);

                                ko.utils.domNodeDisposal.addDisposeCallback($el[0], () => {
                                    this._flowFolderPopover.Destroy($el);

                                    resizeObserver.unobserve(el);
                                });
                            }, 500);
                        });
                    }
                }
            })
            .always(() => BlockUI.Unblock(elem.get(0)));
    }

    private InitRecentAndFavoritesDropdown(el: HTMLElement) {
        let listNavItem = el.closest('.recent-and-favorites-attach-to');

        this._dropDown = new JBoxDropDown({
            target: el,
            bindTarget: el,
            bindComponent: this,
            otherOptions: {
                addClass: 'recent-and-favorites-dropdown',
                closeOnClick: 'body',
                attach: undefined,
                target: $(listNavItem),
                adjustPosition: true,
                adjustTracker: true,
                isolateScroll: true,
                pointer: false,
                maxWidth: 300,
                minWidth: 200,
                minHeight: 100,
                onCloseComplete: () => {
                    if (this._dropDown) {
                        this._dropDown.Destroy();
                        this._dropDown = null;

                        if ($('.page-sidebar-menu').hasClass('page-sidebar-menu-closed')) {
                            const newTarget = $(listNavItem).closest('.subject-area').length
                                ? $(listNavItem).closest('.subject-area')
                                : listNavItem;
                            $(newTarget).removeClass('recent-and-favorites-active');
                        }
                    }
                },
                zIndex: 20001,
                position: {
                    x: 'left',
                    y: 'center',
                },
                outside: 'x',
            },

            onOpen: () => {},
        });

        this._dropDown.Open();
    }

    DestroyRecentAndFavoritesDropdown() {
        this._dropDown?.Destroy();
    }

    SelectUser(user) {
        UserVarsManager.Instance.AddRecent(this._entityId, user.Id, user.TypeId);

        PubSub.publish(PUB_SUB_EVENTS.GO_TO_RECORD_SCREEN, {
            EntityId: this._entityId,
            RecordId: user.Id,
            RecordTypeId: user.TypeId,
        });

        this.Trigger('RECORD_SELECTED');
    }

    GetTemplate() {
        return RecentAndFavoritesTemplate;
    }

    AfterRender(el): void {}
}
